module.exports = __webpack_public_path__ + "static/img/use1.18f36b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/use1.png
// module id = AmfQ
// module chunks = 1